export default __webpack_public_path__ + "static/media/dashboard.1689211d.svg";